/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tr_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Up to 10,000 repetitions. Larger values are capped to keep the tool fast and your browser responsive.`)
};

const es_tr_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hasta 10,000 repeticiones. Los valores más grandes se limitan para mantener la herramienta rápida y tu navegador receptivo.`)
};

const de_tr_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bis zu 10.000 Wiederholungen. Größere Werte werden begrenzt, damit das Tool schnell bleibt und Ihr Browser reaktionsfähig bleibt.`)
};

const nl_tr_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tot 10.000 herhalingen. Grotere waarden worden begrensd om het gereedschap snel te houden en je browser responsief.`)
};

const fr_tr_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jusqu'à 10 000 répétitions. Les valeurs plus grandes sont limitées pour maintenir l'outil rapide et votre navigateur réactif.`)
};

const it_tr_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fino a 10.000 ripetizioni. Valori più grandi sono limitati per mantenere lo strumento veloce e il tuo browser responsivo.`)
};

const pt_br2_tr_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Até 10.000 repetições. Valores maiores são limitados para manter a ferramenta rápida e seu navegador responsivo.`)
};

const pt_tr_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Até 10.000 repetições. Valores maiores são limitados para manter a ferramenta rápida e o seu navegador responsivo.`)
};

const ja_tr_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最大10,000回の繰り返し。より大きな値は、ツールの速度を保ち、ブラウザの応答性を維持するためにキャップされます。`)
};

const zh_tr_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最多可重复 10,000 次。更大的数值会被限制，以确保工具运行迅速、浏览器保持响应。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tr_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tr_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tr_faq1_a", locale)
	if (locale === "en") return en_tr_faq1_a(inputs)
	if (locale === "es") return es_tr_faq1_a(inputs)
	if (locale === "de") return de_tr_faq1_a(inputs)
	if (locale === "nl") return nl_tr_faq1_a(inputs)
	if (locale === "fr") return fr_tr_faq1_a(inputs)
	if (locale === "it") return it_tr_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_tr_faq1_a(inputs)
	if (locale === "pt") return pt_tr_faq1_a(inputs)
	if (locale === "ja") return ja_tr_faq1_a(inputs)
	return zh_tr_faq1_a(inputs)
};